// src/plugins/vuetify.ts
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Importa os estilos do Vuetify
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import { VCalendar, VTimePicker } from '@/libs/vuetify/lib/labs/components.mjs';
import { VDateInput } from 'vuetify/labs/VDateInput'
import { pt } from 'vuetify/locale'

export default createVuetify({
    components: {
        VDateInput,
        
        ...components,
        
    },
    locale: {
        locale: 'pt',
        messages: { pt},
    },
    directives,
    theme: {
        defaultTheme: 'dark',
        themes: {
            light: {
                dark: false,
                colors: {
                    background: '#ffffff',
                    primary: '#1976D2',
                    primaryButton: '#0061c8',
                },
            },
            dark: {
                dark: true,
                colors: {
                    background: '#121212',
                    surface: '#1e1e1e',
                    'surface-bright': '#252525',
                    'surface-light': '#2d2d2d',
                    'surface-variant': '#383838',
                    'on-surface-variant': '#e8e8e8',
                    primary: '#0061c8',
                    primaryButton: '#0061c8',
                    'on-surface': '#ffffff',
                    'on-background': '#ffffff',
                },
                variables: {
                    'border-color': '#ffffff',
                    'border-opacity': 0.28,
                    'high-emphasis-opacity': 1,
                    'medium-emphasis-opacity': 0.9,
                    'disabled-opacity': 0.5,
                },
            },
        },
    },
    icons: {
        defaultSet: 'mdi',
    },
});
